import React from 'react';
import { Link } from 'react-router-dom';

export default class FeatureOne extends React.Component {
    render(){
        return (
            <>
                <section className="feature-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Start Feature One Single */}
                            <div className="col-xl-6 col-lg-6">
                                <div className="feature-one__single">
                                    <div className="shape1"></div>
                                    <div className="feature-one__single-inner">
                                        <div className="feature-one__single-icon">
                                            <span className="icon-crane"></span>
                                        </div>

                                        <div className="feature-one__single-text">
                                            <h2><Link to={process.env.PUBLIC_URL + `/`}>Experiência Comprovada</Link></h2>
                                            <p> Equipe experiente na indústria, oferecendo soluções especializadas e resultados confiáveis.</p>
                                            <div className="feature-one__single-btn">
                                                <Link to={process.env.PUBLIC_URL + `/`}>Ler mais<i className="icon-right-arrow-1"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature One Single */}

                            {/* Start Feature One Single */}
                            <div className="col-xl-6m col-lg-6">
                                <div className="feature-one__single">
                                    <div className="shape1"></div>
                                    <div className="feature-one__single-inner">
                                        <div className="feature-one__single-icon">
                                            <span className="icon-industrial-zone"></span>
                                        </div>

                                        <div className="feature-one__single-text">
                                            <h2><Link to={process.env.PUBLIC_URL + `/`}>Inovação Sustentável</Link></h2>
                                            <p>Compromisso com práticas sustentáveis e tecnologias avançadas.</p>
                                            <div className="feature-one__single-btn">
                                                <Link to={process.env.PUBLIC_URL + `/`}>Ler mais<i className="icon-right-arrow-1"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature One Single */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}